import { ReactChild, ReactChildren } from 'react';

import { faAsterisk, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import { useSelector } from 'hooks';
import styled from 'styled-components';

import { PlannedDuty as PlannedDutyType } from '../types';

import { FontAwesomeSvgIcon, Tooltip } from 'components/shared';

import getTooltipContent from './TooltipContent';

const PlannedDutyStyles = styled.div`
  .employee-btn {
    &:hover {
      text-decoration: underline;
    }
  }
`;

type Props = {
  duty: PlannedDutyType;
  portal: string;
  className: string;
  children: ReactChild | ReactChildren;
};

export default function PlannedDuty({
  duty,
  portal,
  className,
  children
}: Props) {
  // const { assignedEmployee, isDutyHourTypeChanged } = duty;
  const isDutyHourTypeChanged = false;
  const { assignedEmployee } = duty;
  // const isNotFromBaseplan = !isFromBasePlan;
  const isNotFromBaseplan = false;
  const hasTopRighIcons = isDutyHourTypeChanged || isNotFromBaseplan;
  const { hasEmployeeCard } = useSelector((state) => state.grants);

  const { nameInformal: employeeName, id: employeeId } = assignedEmployee;

  const openEmployeeDialog = () => {
    const employeeCardDialog = new window.EmployeeCardDialog({
      viewModel: new window.EmployeeCardDialogViewModel({})
    });
    employeeCardDialog.show({ nameCompound: employeeName, employeeId });
    employeeCardDialog.dialog.onHide = () => {
      employeeCardDialog.destroy();
    };
  };

  return (
    <Tooltip
      title={getTooltipContent(duty)}
      arrow
      enterDelay={300}
      enterNextDelay={300}
      placement="right"
      disableInteractive
    >
      <PlannedDutyStyles className={classNames(className, 'duty', 'planned')}>
        <div className="duty-header">
          {portal === 'roster' && hasEmployeeCard ? (
            <button
              type="button"
              className="clean-btn employee-btn"
              onClick={openEmployeeDialog}
            >
              {employeeName}
            </button>
          ) : (
            employeeName
          )}
        </div>
        {children}
        {hasTopRighIcons && (
          <div className="top-right-icons">
            {isDutyHourTypeChanged && (
              <FontAwesomeSvgIcon
                icon={faAsterisk}
                fontSize="small"
                className="dht-changed"
              />
            )}
            {isNotFromBaseplan && (
              <FontAwesomeSvgIcon icon={faChevronUp} fontSize="small" />
            )}
          </div>
        )}
      </PlannedDutyStyles>
    </Tooltip>
  );
}
